import { Component, Shark } from "shark-mvc";

import templateContent from "./refresh-list-button.html";

class RefreshListButtonComponent extends Component {
	constructor() {
		super("refreshListButtonComponent");

		this.addTemplate("", templateContent);
	}
	
	// init () {
	// 	this.set("loading", false);
	// }
	
	refreshListBtn_clickHandler () {
		// this.set("loading", true);
		document.querySelectorAll(".refreshListBtn").forEach(item => item.classList.add("loading"));
		const activeView = Shark.activePage;

		if (activeView && typeof activeView.refreshList === "function") {
			activeView.refreshList(null, true);
		}
	}

	resetStatus () {
		document.querySelectorAll(".refreshListBtn").forEach(item => item.classList.remove("loading"));
	}
}

const refreshListButtonComponent = new RefreshListButtonComponent();

Shark.registerComponent(refreshListButtonComponent);

export default refreshListButtonComponent;
